module.exports = __webpack_public_path__ + "static/invisionAlternative-8a2d7c52974dd20561ea9972cecb1a46.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/marvel-vs-invision/invisionAlternative.png
// module id = 2662
// module chunks = 260617349216052